import { render, staticRenderFns } from "./OrkHomeGallery.html?vue&type=template&id=beaf591e&scoped=true&"
import script from "./OrkHomeGallery.vue?vue&type=script&lang=js&"
export * from "./OrkHomeGallery.vue?vue&type=script&lang=js&"
import style0 from "./OrkHomeGallery.scss?vue&type=style&index=0&id=beaf591e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf591e",
  null
  
)

export default component.exports